'use strict';

export default class SearchRoutePoint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.point.title || '',
            icao: props.point.icao || '',
            flag_img: props.point.flag_img || '',
        }
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        const {index, airports, direction, onSelect, dropDownParent = '.page'} = this.props;
        const that = this;

        $.widget( "app.autocomplete", $.ui.autocomplete, {
            _renderItem: function( ul, item ) {
                item.label = item.title;
                let result = $("<li>")
                    .append(`
                        <div class="autocomplete-item">
                            <img src="${item.flag_img}" class="flag-icon">
                            <div>${item.title}</div>
                            <span class="code">${item.icao || ''}</span>
                        </div>
                    `)
                result.appendTo(ul)
                return result;
            }
        });

        this.el = $(`.routePoint${direction}${index}`);
        const parent = this.el.closest(dropDownParent) || undefined;
        this.el.autocomplete({
            minLength: 0,
            delay: 300,
            appendTo: parent,
            source: airports,
            select: function (item, ui) {
                item.preventDefault();
                onSelect(ui.item);
                that.setState({
                    value: ui.item.title,
                    icao: ui.item.icao,
                    flag_img: ui.item.flag_img,
                })
            },
            open: function () {
                var acData = $(this).autocomplete("widget");
                acData.css("top", parseInt(acData.css("top")) + 5 + "px");

                const $input = $(this);
                const $menu = $input.autocomplete("widget");

                $menu.position({
                    my: "left top",
                    at: "left bottom+5",
                    of: $input
                });

                $(window).on("scroll.autopos", function () {
                    $menu.position({
                        my: "left top",
                        at: "left bottom+5",
                        of: $input
                    });
                });
            },
        }).bind('focus', function () {
            if (!$(this).val().trim()) {
                $(this).keydown();
            } else {
                $(this).next('.direction-code').hide();
                $(this).select();
            }
        }).bind('blur', function () {
            $(this).next('.direction-code').show();
        })

        $(window).scroll(function() {
            if (!window.isAnimatedScrolling) {
                that.el.blur();
                that.el.autocomplete('close');
            }
        });
    }

    isEqual(o1, o2) {
        return JSON.stringify(o1) === JSON.stringify(o2);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const {airports, point, error} = this.props;
        const {value} = this.state;
        let update = false;
        if(!this.isEqual(airports, nextProps.airports)) {
            this.el.autocomplete('option', 'source', nextProps.airports)
            this.el.autocomplete('option', 'delay', 10)
            update = true;
        }
        if(!this.isEqual(point, nextProps.point)) {
            this.setState({
                value: nextProps.point.title || '',
                icao: nextProps.point.icao || '',
                flag_img: nextProps.point.flag_img || '',
            })
            update = true;
        }
        if(!this.isEqual(value, nextState.value)) update = true;
        if(!this.isEqual(error, nextProps.error)) update = true;
        return update;
    }

    handleChange(value) {
        const {onSelect, onlyAirports, maxAirports} = this.props;

        const query_params = [
            {key: "onlyAirports", value: onlyAirports ? 1 : 0},
            {key: "max", value: maxAirports}
        ]
            .filter(e => !!e.value)
            .map(({key, value}) => `${key}=${value}`)
            .join('&')

        let source = (request, response) => $.ajax({
            url: apiAction.apiUrl(`autocomplete/airportOrCity${!!query_params ? `?${query_params}` : ''}`),
            dataType: "json",
            data: apiAction.prepareData(request),
            success: response,
        });

        let delay = 300;
        if(!value.trim()) {
            source = this.props.airports;
            delay = 10;
        }
        this.el.autocomplete('option', 'source', source);
        this.el.autocomplete('option', 'delay', delay);
        onSelect({});
        this.setState({
            value: value.replace(/^\s+/, '') || '',
            icao: '',
            flag_img: '',
        })
    }

    render() {
        const {index, direction, label, error, onFocus} = this.props;
        const {value, icao, flag_img} = this.state;
        return <div className={clsx(`search-inputbox direction-${direction}`, error && 'error', flag_img && 'changed')}>
            {flag_img && <img src={flag_img} className="direction-flag"/>}
            <input type="text" placeholder={label} className={`routePoint${direction}${index}`} value={value} onChange={(e) => this.handleChange(e.target.value)} onFocus={() => onFocus && onFocus()}/>
            <span className="direction-code">{icao}</span>
            {!!value && <a role='button' className="search-inputbox__clear" style={{display:'block'}} onClick={(e) => this.handleChange('')}></a>}
        </div>
    }
}
